import { render } from "./star-rating.vue?vue&type=template&id=c0f5f62c&scoped=true"
import script from "./star-rating.vue?vue&type=script&lang=js"
export * from "./star-rating.vue?vue&type=script&lang=js"

import "./star-rating.vue?vue&type=style&index=0&id=c0f5f62c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0f5f62c"

export default script